<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-clipboard mr-2" />Plan Baru</h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Wilayah Tujuan">
                        <multiselect v-model="input.wilayah"
                            :options="optWilayah"
                            :allow-empty="false"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Wilayah"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Lokasi Tujuan">
                        <multiselect v-model="input.lokasi"
                            :options="optLokasi"
                            :allow-empty="false"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Lokasi"
                            :disabled="input.wilayah == null"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Keterangan / Tujuan Akhir">
                        <b-form-input v-model="input.keterangan" maxlength="100" />
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- <b-button variant="dark" @click="$bvModal.show('modal-search')">
                <i class="fa fa-plus mr-2" />Tambah Unit
            </b-button> -->
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Tambah Elektrik / ESP" class="mb-2 font-weight-bold">
                        <b-input-group>
                            <b-form-input placeholder="SN" v-model="input.sn" @keydown.enter="searchAndAdd" />
                            <b-input-group-append>
                                <b-button variant="primary" @click="searchAndAdd" :disabled="isSubmitting">
                                    <i class="fa fa-plus mr-2" /> Tambahkan Unit
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada unit terpilih.
                </template>
                <template v-slot:cell(type)="row">
                    {{ row.item.type }}
                    <div class="small text-muted">{{ row.item.manufacturer }}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseInventoryStatusBadge(row.item.status)">{{ row.item.status }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="danger" v-b-tooltip.hover.top title="Hapus" @click="doRemoveItem(row.item.id)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <hr class="mt-4 mb-4" />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Tambah Engine" class="mb-2 font-weight-bold">
                        <b-input-group>
                            <b-form-input placeholder="SN" v-model="input.snEngine" @keydown.enter="engineSearchAndAdd" />
                            <b-input-group-append>
                                <b-button variant="primary" @click="engineSearchAndAdd" :disabled="isSubmitting">
                                    <i class="fa fa-plus mr-2" /> Tambahkan Unit
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty
                :items="engines"
                :fields="fieldsEngine"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada engine terpilih.
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseEngineStatusVariantTipe(row.item.status.id)">{{ row.item.status.name }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="danger" v-b-tooltip.hover.top title="Hapus" @click="doRemoveEngine(row.item.id)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <b-button variant="primary" @click="openConfirmModal">
                <i class="fa fa-save mr-2" /> Buat dan Simpan Plan
            </b-button>
        </b-card>
        <b-modal id="modal-search" size="lg" title="Pencarian Unit" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <b-row>
                <!-- <b-col md="4">
                    <b-form-select v-model="search.category" :options="optCategory">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Kategori</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col> -->
                <b-col md="9">
                    <b-form-input v-model="search.sn" maxlength="100" placeholder="SN" @keydown.enter="searchAndAdd" />
                </b-col>
                <b-col md="3">
                    <b-button variant="primary" block @click="searchAndAdd" :disabled="isSubmitting">
                        {{ isSubmitting ? "Menambahkan..." : "Tambahkan" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal id="modal-confirm" title="Konfirmasi Pembuatan Plan Baru" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <div class="mb-3">
                Konfirmasi pembuatan plan untuk tujuan <b>{{ input.lokasi ? input.lokasi.name : "-" }}</b>, <b>{{ input.wilayah ? input.wilayah.name : "-" }}</b> sebanyak <b>{{ items.length + engines.length }}</b> unit?
            </div>
            <div class="text-right">
                <b-button variant="primary" @click="submitPlan" :disabled="isSubmitting">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'plan-create',
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            bypassLeave: false,

            input: {
                wilayah: null,
                lokasi: null,
                sn: "",
                snEngine: "",
                keterangan: ""
            },

            search: {
                sn: "",
                category: null,
            },

            fields: [
                { key: "category", label: "Kategori" },
                { key: "sn", label: "SN" },
                { key: "type", label: "Tipe / Manufaktur" },
                { key: "search1", label: "Info" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi"},
            ],

            fieldsEngine: [
                { key: "sn", label: "SN" },
                { key: "type", label: "Tipe" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi"},
            ],

            items: [],
            engines: [],

            optWilayah: [],
            optLokasi: [],
            optCategory: []

        }
    },
    methods: {

        init() {

            this.initStatus = 0

            let getWilayah = this.$axios.get("wilayah/selection?all=true").then(res => {
                this.optWilayah = res.data
            })

            // let getCategory = this.$axios.get("plan/get-category").then(res => {
            //     this.optCategory = res.data.map(it => { return { value: it.id, text: it.name } })
            // })

            Promise.all([getWilayah]).then(res => {
                this.initStatus = 1
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            })

        },

        searchAndAdd() {

            if(this.isSubmitting == true) { return }

            this.isSubmitting = true

            let payload = new FormData()
            payload.append("sn", this.input.sn)

            this.$axios.post("plan/get-inventory", payload).then(res => {

                // Cek apabila sudah ada IDnya
                if(this.items.find(it => it.id == res.data.id && it.category == res.data.category)) {
                    this.$helper.toastError(this, "SN dan kategori ini sudah ada pada daftar unit!")
                }
                else {
                    this.$helper.toastSuccess(this, "Berhasil menambahkan unit!")
                    this.items.push(res.data)
                    // this.$bvModal.hide("modal-search")
                    this.input.sn = ""
                }

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        engineSearchAndAdd() {
            if(this.isSubmitting == true) { return }
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("sn", this.input.snEngine)

            this.$axios.post("plan/get-engine", payload).then(res => {

                // Cek apabila sudah ada IDnya
                if(this.engines.find(it => it.id == res.data.id)) {
                    this.$helper.toastError(this, "SN ini sudah ada pada daftar unit!")
                }
                else {
                    this.$helper.toastSuccess(this, "Berhasil menambahkan engine!")
                    this.engines.push(res.data)
                    // this.$bvModal.hide("modal-search")
                    this.input.snEngine = ""
                }

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        doRemoveItem(id) {
            let index = this.items.findIndex(it => it.id == id)
            this.items.splice(index, 1)
        },

        doRemoveEngine(id) {
            let index = this.engines.findIndex(it => it.id == id)
            this.engines.splice(index, 1)
        },

        openConfirmModal() {

            if(this.input.lokasi == null) {
                return this.$helper.toastError(this, "Mohon memilih tujuan lokasi!")
            }

            let totalItemLength = this.items.length + this.engines.length

            if(totalItemLength == 0) {
                return this.$helper.toastError(this, "Minimal memilih 1 unit!")
            }

            this.$bvModal.show("modal-confirm")

        },

        submitPlan() {

            let payload = new FormData()
            payload.append("lokasiId", this.input.lokasi.id)

            if(!this.$helper.isBlank(this.input.keterangan)) {
                payload.append("keterangan", this.input.keterangan)
            }

            this.items.forEach(item => {
                payload.append("inventoryIds", item.id)
            })

            this.engines.forEach(engine => {
                payload.append("engineIds", engine.id)
            })

            this.isSubmitting = true
            this.$axios.post("plan/", payload).then(res => {

                let id = res.data.id
                this.bypassLeave = true
                this.$router.push("/plan/" + id)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        parseInventoryStatusBadge(status) {

            switch(status) {
                case "READY LINE": return "dark"
                case "RETUR": return "warning"
                case "REPAIR": return "danger"
                default: return "light"
            }

        },

        parseEngineStatusVariantTipe(id) {
            switch(id) {
                case 0: return "dark"
                case 1: return "success"
                case 2: return "danger"
                case 3: return "primary"
                case 4: return "warning"
                default: return "light"
            }
        },

    },
    watch: {

        "input.wilayah": function(newVal) {

            this.input.lokasi = null

            if(newVal == null) {
                return
            }

            this.$axios.get("lokasi/selection/" + newVal.id).then(res => {
                this.optLokasi = res.data
            })

        }

    },
    created() {
        this.init()
    },
    beforeRouteLeave(to, from, next) {

        if(this.items.length != 0 && !this.bypassLeave) {

            const answer = window.confirm('Tinggalkan halaman ini?')
            if(answer) {
                next()
            }
            else {
                next(false)
            }

        }
        else {
            next()
        }

    }
}
</script>
